export default __webpack_public_path__ + "static/buildon_sg_2019_2-89457f2cfb6bbbe064df306a3f8f9f79.jpg";